import { Metamodel } from '../base/model';
import { IModel } from '../base/annotation';
import { LinkedService } from '../linkedservice/linkedservice';

import { AzureKeyVault } from 'app/model/linkedservice/key-vault';
import { adfModelTypeMap } from '../../registries/consts/adf-model-type-map-const';
import { validateAKVLinkedserviceReference } from 'app/shared/utils/linkedservice-validation-util';
import { format } from 'app/shared/utils/string.util';

@Metamodel.model({
    name: adfModelTypeMap.sapOpenHub.linkedServiceType,
    display: [
        format(stringResources.ModelName_LinkedServiceTemplate, stringResources.SapOpenHub_DisplayText),
        format(stringResources.ModelName_LinkedServicesTemplate, stringResources.SapOpenHub_DisplayText)
    ]
})
export class SapOpenHubLinkedService extends LinkedService {

    public static readonly MODEL: IModel;

    @Metamodel.attribute({
        display: stringResources.ModelName_Host
    })
    public server?: string;

    @Metamodel.attribute({
        display: stringResources.ModelName_Port
    })
    public systemNumber?: string;

    @Metamodel.attribute({
        display: stringResources.ModelName_Sid
    })
    public clientId?: string;

    @Metamodel.attribute({
        display: stringResources.Language
    })
    public language?: string;

    @Metamodel.attribute({
        display: stringResources.ModelName_UserName
    })
    public userName?: string;

    @Metamodel.attribute({
        display: stringResources.ModelName_Password,
        constraint: {
            validator: validateAKVLinkedserviceReference
        }
    })
    public password?: string | AzureKeyVault;

    public logonType: 'applicationServer' | 'group' = 'applicationServer'; // ui only

    @Metamodel.attribute({
        display: stringResources.ModelName_MessageServer
    })
    public messageServer?: string;

    @Metamodel.attribute({
        display: stringResources.ModelName_MessageServerService
    })
    public messageServerService?: string;

    @Metamodel.attribute({
        display: stringResources.ModelName_SystemId
    })
    public systemId?: string;

    @Metamodel.attribute({
        display: stringResources.ModelName_LogonGroup
    })
    public logonGroup?: string;

    constructor(name?: string, description?: string) {
        super(name, description);
    }
}
